var map = {
	"./ADDVA_ENTRAN.svg": 45,
	"./ADDVA_EXCLUS.svg": 46,
	"./ADDVA_GUIDE.svg": 47,
	"./ADDVA_KIDS.svg": 48,
	"./ADDVA_LOCAL.svg": 49,
	"./ADDVA_MEAL.svg": 50,
	"./ADDVA_PRITOU.svg": 51,
	"./ADDVA_SMALL.svg": 52,
	"./ADDVA_SUBJEC.svg": 53,
	"./ADDVA_TOURAU.svg": 54,
	"./ADDVA_VOUCH.svg": 55,
	"./default_icon.svg": 56,
	"./fast.svg": 57,
	"./free.svg": 58,
	"./istant.svg": 59,
	"./official.svg": 60,
	"./skip.svg": 61
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 281;